import { render, staticRenderFns } from "./menu_contents.vue?vue&type=template&id=0d39b8db&"
import script from "./menu_contents.vue?vue&type=script&lang=js&"
export * from "./menu_contents.vue?vue&type=script&lang=js&"
import style0 from "./menu_contents.vue?vue&type=style&index=0&id=0d39b8db&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports